export type { BaseModalProps, DesktopModalWrapperProps, DesktopSizing, MobileModalWrapperProps } from './modal';
export { desktopSizes } from './modal';
